import { render } from "./vdvclist.vue?vue&type=template&id=5d9b5460&scoped=true"
import script from "./vdvclist.vue?vue&type=script&lang=js"
export * from "./vdvclist.vue?vue&type=script&lang=js"

import "./vdvclist.vue?vue&type=style&index=0&id=5d9b5460&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9b5460"]])

export default __exports__